import { indexBy, prop } from 'ramda'

export enum EStatusPill {
  Available = 'Available',
  Preparing = 'Preparing',
  Charging = 'Charging',
  SuspendedEVSE = 'SuspendedEVSE',
  SuspendedEV = 'SuspendedEV',
  Finishing = 'Finishing',
  Reserved = 'Reserved',
  Unavailable = 'Unavailable',
  Faulted = 'Faulted',
  Repairing = 'repairing',
}

export const useChargeStatusEnum = () => {
  const statusEnum = Object.fromEntries(
    Object.entries(EStatusPill).map(([key, value]) => [key, value])
  )

  const data = [
    {
      id: 'Available',
      label: '可使用',
    },
    {
      id: 'Preparing',
      label: '準備充電',
    },
    {
      id: 'Charging',
      label: '充電中',
    },
    {
      id: 'SuspendedEVSE',
      label: '充電樁停止充電',
    },
    {
      id: 'SuspendedEV',
      label: '車輛停止充電',
    },
    {
      id: 'Finishing',
      label: '充電完畢',
    },
    {
      id: 'Reserved',
      label: '預定',
    },
    {
      id: 'Unavailable',
      label: '無服務',
    },
    {
      id: 'Faulted',
      label: '故障',
    },
  ]

  const byId = indexBy(prop('id'), data)

  return {
    data,
    byId,
    statusEnum,
  }
}

export const useParkingSpaceEnum = () => {
  const data = [
    {
      key: 'PRIORITY',
      label: '優先車格',
    },
    {
      key: 'DEDICATED',
      label: '專用車格',
    },
  ]

  const byKey = indexBy(prop('key'), data)

  return {
    data,
    byKey,
  }
}
